import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

import {SERVER_API_URL} from 'app/app.constants';
import {createRequestOption} from 'app/shared';
import {IRunningAccount} from 'app/shared/model/FDERunningAccountService/account-running.model';
import {IRunnerAlive} from 'app/shared/model/FDERunningAccountService/runner-alive.model';
import {IExecutionRow, IQueueRow, IRecentExecutionRow} from 'app/shared/model/FDERunningAccountService/execution.model';

type EntityArrayResponseType = HttpResponse<IRunningAccount[]>;

@Injectable({providedIn: 'root'})
export class RunningAccountService {
    public resourceUrl = SERVER_API_URL + 'api/v2/accounts/running';

    constructor(protected http: HttpClient) {
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IRunningAccount[]>(this.resourceUrl, {params: options, observe: 'response'});
    }

    queryWatchdog(): Observable<HttpResponse<IRunnerAlive[]>> {
        return this.http
            .get<IRunnerAlive[]>(`${this.resourceUrl}/watchdog`, {observe: 'response'});
    }

    queryExecutions(): Observable<HttpResponse<IExecutionRow[]>> {
        return this.http
            .get<IExecutionRow[]>(`${this.resourceUrl}/executions`, {observe: 'response'});
    }

    queryQueue(): Observable<HttpResponse<IQueueRow[]>> {
        return this.http
            .get<IQueueRow[]>(`${this.resourceUrl}/queue`, {observe: 'response'});
    }

    queryRecent(): Observable<HttpResponse<IRecentExecutionRow[]>> {
        return this.http
            .get<IRecentExecutionRow[]>(`${this.resourceUrl}/recent`, {observe: 'response'});
    }
}
